export default __webpack_public_path__ + "static/media/logo-humane.f8b7f921.svg";